module.exports = __webpack_public_path__ + "img/logo.be5d8f12.jpg";